import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import api from '../../common/apiService';
import { parseISO, format } from 'date-fns';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Chip,
  Button,
  Grid
} from '@material-ui/core';

import { Toolbar } from './components';
import config from '../../config/config.json';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  card: {
    width: '50%'
  }
}));

const paymentTypesLabels = {
  '1': 'Сайт',
  '2': 'Наличные',
  '3': 'Альфасчет',
  '4': 'Вестерн Юнион',
  '5': 'Тинькофф',
  '6': 'Депозит',
  '7': 'Кредит',
  '8': 'Электр. добро',
  delivery: 'Оплата за доставку',
  dobro: 'Оплата за добро'
};

const ReportDaysMoney = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [report, setReport] = useState([]);
  const [total, setTotal] = useState(0);

  const getData = async () => {
    const reportApi = await api.getDaysMoneyReport(
      selectedStartDate,
      selectedEndDate
    );
    // console.log('reportApi', reportApi);
    setReport(reportApi);
    setTotal(
      Object.keys(reportApi).reduce((res, key) => {
        res += reportApi[key];
        return res;
      }, 0)
    );
    //   console.log('reportApi',reportApi);
  };

  useEffect(() => {
    // Получим списки сессий и пользователей
    getData();
  }, []);

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  const handleMakeReport = () => {
    getData();
  };

  return (
    <div className={classes.root}>
      <Toolbar
        startDate={selectedStartDate}
        endDate={selectedEndDate}
        total={total}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={handleEndDateChange}
        onMakeReport={handleMakeReport}
      />

      <div className={classes.content}>
        {report && (
          <Card
            //   {...rest}
            className={classes.card}>
            <CardContent className={classes.content}>
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Тип платежа</TableCell>
                        <TableCell>Сумма</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(report).map(key => (
                        <TableRow className={classes.tableRow} hover key={key}>
                          <TableCell>{paymentTypesLabels[key]}</TableCell>
                          <TableCell>
                            {`${report[key].toLocaleString('ru')}`}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </PerfectScrollbar>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default ReportDaysMoney;
